var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.002,
    height: 24.002
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.001 24.001a54.726 54.726 0 01-4-5.427c-1.825-2.838-4-6.906-4-10.172a8.561 8.561 0 012.35-5.961 7.774 7.774 0 015.65-2.44 7.771 7.771 0 015.65 2.441 8.56 8.56 0 012.351 5.961c0 3.266-2.175 7.334-4 10.172a54.726 54.726 0 01-4 5.427zm0-19a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3z",
    fill: "#17bed0"
  })));
}
export default SvgPingIcon;